import React from 'react';
import { createRoot } from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import moment from 'moment';

import App from 'app/App';
import googleTagManager from 'app/analytics/GoogleTagManager';
import YandexMetrica from 'app/analytics/YandexMetrica';

const container = document.getElementById('root');
const root = createRoot(container);

googleTagManager.initialize((window as any).env.GOOGLE_TAG_MANAGER_ID);

function InitializeMemoryRouter() {
    const pathname = window.location.pathname;
    const search = window.location.search;

    return (
        <>
            <YandexMetrica />
            <MemoryRouter initialEntries={[pathname + search]} initialIndex={0}>
                <App />
            </MemoryRouter>
        </>
    );
}

//todo: определить место конфигурации.
moment.fn.toJSON = function () {
    return this.isValid() ? this.format('YYYY-MM-DD') : null;
};

root.render(<InitializeMemoryRouter />);
